export const pageMap = {}

export const settings = {
  logo: {
    navBar: '/images/logo.svg',
    footer: '/images/logo-white.png'
  },
  contact: {},
  social: {
    facebook: 'https://facebook.com',
    linkedin: 'https://linkedin.com',
    twitter: 'https://twitter.com'
  },
  footerCopyright: { fr: 'Tous droits réservés | Forum IA Québec', en: 'All rights reserved | Forum IA Québec' },
  navigation: {
    contactLabel: { en: 'Contact us', fr: 'Nous joindre' },
    links: [
      {
        label: { en: 'About the Forum', fr: 'À propos du Forum' },
        to: { name: 'about' },
        anchors: {
          mission: { en: 'Mission', fr: 'Mission' },
          team: { en: 'Team', fr: 'Équipe' },
          board: { en: 'Board of Directors', fr: "Conseil d'administration" },
          consultatives: { en: 'Advisory Committees', fr: 'Comités consultatifs' }
        }
      },
      {
        label: { en: 'Artificial Intelligence', fr: 'L’intelligence artificielle' },
        to: { name: 'ai' },
        anchors: {
          intro: { en: 'What is AI?', fr: "Qu'est-ce que l’IA ?" },
          context: { en: 'The Forum and AI', fr: "L'IA au Forum" },
          effects: { en: 'Impacts of AI', fr: "Retombées de l'IA" },
          actors: { en: 'The AI Ecosystem', fr: "L'écosystème en IA" }
        }
      },
      {
        label: { en: 'Projects', fr: 'Projets' },
        to: { name: 'projects' },
        anchors: {
          promotion: { en: 'Promotion', fr: 'Rayonnement' },
          performance: { en: 'Performance', fr: 'Performance' },
          talent: { en: 'Talent', fr: 'Talent' },
          adoption: { en: 'Adoption', fr: 'Adoption' },
          society: { en: 'Society', fr: 'Société' }
        }
      },
      {
        label: { en: 'Reference Documents', fr: 'Documents de référence' },
        to: { name: 'documents' }
      },
      {
        label: { en: 'News', fr: 'Nouvelles' },
        to: { name: 'news' }
      }
    ],
    bannerTitle: {
      fr: 'Découvrez votre nouvelle porte d’entrée vers l’écosystème québécois de l’IA',
      en: 'Discover your new gateway to Quebec’s AI ecosystem'
    },
    bannerRedirect: {
      fr: 'visitez la Vitrine IA Québec',
      en: 'visit the Vitrine AI Quebec'
    }
  }
}
